



















  import { ChampFormulaire } from '@/commun/components/champ-formulaire';
  import { StepperNombre } from '@/commun/components/champ-formulaire/stepper-nombre';
  import Vue from 'vue';

  export default Vue.extend({
    name: 'StepperCredits',
    components: {
      ChampFormulaire,
      StepperNombre,
    },
    inheritAttrs: false,
    props: {
      value: {
        type: Number,
        default: null,
      },
      minCredits: {
        type: Number,
        default: 0,
      },
      maxCredits: {
        type: Number,
        default: 999,
      },
    },
    data: () => ({
      valeurInterne: 0,
    }),
    methods: {
      onInput(valeur: number): void {
        this.$emit('input', valeur);
      },
    },
  });
